module.exports = __webpack_public_path__ + "static/media/logo.588d2ebc.png";